<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h1">THE DEVIL TREE</h1>
<p class="author"><a id="page_vii"></a><a id="title"></a><strong>Jerzy Kosinski</strong></p>
<p class="subtitlea"><strong><span class="small">A NOVEL</span></strong></p>
<p class="subtitle">REVISED AND EXPANDED</p>
<p class="pubimage"><img alt="Image" src="images/pub.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?8fed32da